<!-- {{ factureFR | json }}  -->
<mat-dialog-content class="dialogcontent flexcolumn">

  <div class="flexbetween" [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[0]) || 'etat-unknown'">
    <div class="flexrow">
      <span class="title">Bénéficiaire</span>
      <span class="value">{{ factureFR.beneficiaire.numSecu }}&nbsp;{{ factureFR.beneficiaire.nom }}&nbsp;{{ factureFR.beneficiaire.prenom }} </span>
    </div>
    <div >{{ stateHelper.getEtatFacture(dialogdata.fSEOrder, dialogdata.fSEOrder.etatFactureRSP[0], true) }} </div>
  </div>

  <div class="flexrow">
    <span class="title">État AMO: <span [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[1])">{{ stateHelper.statusLabelShort[dialogdata.fSEOrder.etatFactureRSP[1]] }}</span></span>
    <span class="title">État AMC: <span [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[2])">{{ stateHelper.statusLabelShort[dialogdata.fSEOrder.etatFactureRSP[2]] }}</span></span>
  </div>

  @if (dialogdata.fSEOrder.data.annulDRE) {
    <div class="title etat-rsp-rejet">
      Une DRE d’annulation a été générée pour cette facture
    </div>
  }

  @if (prestations.length) {
    <fieldset class="flexcolumn" style="margin-top:6px;">
      <legend>Détail des prestations</legend>
      <div class="grid grid-header">
        <div class="grid-cell">Prest.</div>
        <div class="grid-cell">LPP</div>
        <div class="grid-cell">PU Conv.</div>
        <div class="grid-cell">PU Vente</div>
        <div class="grid-cell">Qté</div>
        <div class="grid-cell">Honoraires</div>
        <div class="grid-cell">Mnt. AMO</div>
        <div class="grid-cell">Mnt. AMC</div>
        <div class="grid-cell">A Charge</div>
        <div class="grid-cell">Date exé.</div>
        <div class="grid-cell">Typ</div>
        <div class="grid-cell">Début Loc.</div>
        <div class="grid-cell">Fin Loc.</div>
        <div class="grid-cell">Tx remb. AMO</div>
      </div>
      <div class="separator-line"></div>
      @for (line of prestations; track line; let i = $index) {
        <div class="grid" [class.parity_table_line]="i % 2 === 0">
          <div class="grid-cell">{{ line.codePresta }}</div>
          <div class="grid-cell">{{ line.LPP?.codeLPP }}</div>
          <div class="grid-cell alignright">{{ $safeNavigationMigration(line.LPP?.tarifLPP) | fcfse }}</div>
          <div class="grid-cell alignright">{{ $safeNavigationMigration(line.LPP?.prixUnitairePublicLPP) | fcfse }}</div>
          <div class="grid-cell alignright">{{ line.quantite }}</div>
          <div class="grid-cell alignright">{{ line.montantHonoraires | fcfse }}</div>
          <div class="grid-cell alignright">{{ line.montantRemboursementAMO | fcfse }}</div>
          <div class="grid-cell alignright">{{ line.montantRemboursementAMC | fcfse }}</div>
          <div class="grid-cell alignright">{{ aCharge(line) | fcfse }}</div>
          <div class="grid-cell aligncenter">{{ line.dateExec | fseToFrDateFormat}}</div>
          <div class="grid-cell">{{ line.LPP?.typePrestaLPP }}</div>
          <div class="grid-cell aligncenter">{{ (line.LPP?.dateDebut ? (line.LPP?.dateDebut | fseToFrDateFormat) : '&nbsp;') }}</div>
          <div class="grid-cell aligncenter">{{ (line.LPP?.dateFin ? (line.LPP?.dateFin | fseToFrDateFormat) : '&nbsp;') }}</div>
          <div class="grid-cell">{{ line.tauxRemboursementAMO }}</div>
        </div>
      }
      <div class="separator-line"></div>
      <!-- Totals row -->
      <div class="grid">
        <div class="grid-cell total0">Total remboursable</div>
        <div class="grid-cell alignright">{{ $safeNavigationMigration(factureFR.totalFacture?.totalFacture) | fcfse }}</div>
        <div class="grid-cell alignright">{{ $safeNavigationMigration(factureFR.totalFacture?.totalRemboursableAmo) | fcfse }}</div>
        <div class="grid-cell alignright">{{ factureFR.totalFacture?.totalRemboursableAmc??'' | fcfse }}</div>
        <div class="grid-cell alignright">{{ totalACharge | fcfse }}</div>
      </div>
      <hr/>
      <!-- Payments row -->
      <div class="grid">
        <div class="grid-cell total1">Total remboursements</div>
        <div class="grid-cell alignright">{{ +(dialogdata.fSEOrder.payedAMO) +  +(dialogdata.fSEOrder.payedAMC)| fc }}</div>
        <div class="grid-cell alignright">{{ dialogdata.fSEOrder.payedAMO | fc }}</div>
        <div class="grid-cell alignright">{{ dialogdata.fSEOrder.payedAMC | fc }}</div>
      </div>
      <!-- Amounts due row -->
      @if (dialogdata.fSEOrder.etatFactureRSP[0] !== 'P' || (dialogdata.fSEOrder.duAmo == 0 && dialogdata.fSEOrder.duAmc == 0)) {
        <div class="grid">
          <div class="grid-cell total1">Total montants dûs</div>
          <div class="grid-cell alignright" [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[0])">
            {{ +(dialogdata.fSEOrder.duAmo??0) + +(dialogdata.fSEOrder.duAmc??0) | fc }}
          </div>
          <div class="grid-cell alignright" [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[1])">
            {{ dialogdata.fSEOrder.duAmo | fc }}
          </div>
          <div class="grid-cell alignright" [ngClass]="stateHelper.getEtatFactureClass(dialogdata.fSEOrder.etatFactureRSP[2])">
            {{ dialogdata.fSEOrder.duAmc | fc }}
          </div>
        </div>
      }
    </fieldset>
  }
  <div class="flexrow buttonbar">
    @if (true) {
      <div class="">
        <button mat-flat-button color="secondary" type="button" aria-label="Annuler DRE" (click)="genDREannul()">Générer DRE d'annulation"</button>
      </div>
    }
    @if ((dialogdata.fSEOrder.etatFactureRSP[0] !== 'P') && (dialogdata.fSEOrder.etat_facture !== 'PAYÉ_FORÇAGE')) {
      <div class="">
        <button mat-flat-button color="secondary" type="button" aria-label="Forcage" (click)="forcerEtatFacture(true)">Forcer l'état "Payé"</button>
      </div>
    }
    @if (dialogdata.fSEOrder.etat_facture == 'PAYÉ_FORÇAGE') {
      <div class="flexrow buttonbar">
        <button mat-flat-button color="secondary" type="button" aria-label="Forcage" (click)="forcerEtatFacture(false)">Annuler le forçage "Payé"</button>
      </div>
    }
  </div>
</mat-dialog-content>
